// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pi-rotation{transform:rotate(45deg);margin-left:5px}`, "",{"version":3,"sources":["webpack://./src/EmploymentBillboard/App/components/PartialIcon/PartialIcon.scss"],"names":[],"mappings":"AAAA,aACI,uBAAA,CACA,eAAA","sourcesContent":[".pi-rotation{\r\n    transform: rotate(45deg);\r\n    margin-left: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
